import * as React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { toggleSidebar } from "../../store";
import { Header, Container, Label, Menu, Icon } from "semantic-ui-react";
import { MenuProps } from "../Menu";

interface HeaderMenuProps extends MenuProps {
  dispatch?: Dispatch<any>;
  inverted?: boolean;
}

export const HeaderMenu = ({ items, pathname, Link, inverted, dispatch }: HeaderMenuProps) =>
  <div style={{width: "100%"}} className="headerContainer">
  <Container style={{marginBottom: "2em"}}>
    <Menu size="large" secondary inverted>
      <Menu.Item as="a" className="mobile only" icon="sidebar"
        onClick={() => dispatch && dispatch(toggleSidebar())} />
        <Menu.Item>
          <div className="menuHeaderContainer">
          <Link to="/"><Header as="h2" inverted>Dr. Stephanie Schwartz</Header></Link>
          <a href="http://cs.millersville.edu"><Header as="h2" sub inverted>Professor and Chair of Computer Science</Header></a>
          <a href="http://www.millersville.edu"><Header as="h2" sub inverted>Millersville University</Header></a>
          </div>
        </Menu.Item>
        <Menu.Menu position="right">
      {items.map((item) => {
        const active = (item.exact) ? pathname === item.path : pathname.startsWith(item.path);
        if (item.component) {
          return item.component(active);
        } else {
          return <Menu.Item
            as={Link}
            className="mobile hidden"
            name={item.name}
            to={item.path}
            key={item.path}
            active={active}
          />;
        }
      })}
      </Menu.Menu>
    </Menu>
    <style jsx>{`
        .menuHeaderContainer {
          :global(h2) {
            margin: 0em !important;
          }
        }
    `}</style>
  </Container>
  </div>;

export default connect()(HeaderMenu);
